import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NetworkType } from '@src/app/enum/network.enum';

@Component({
  selector: 'app-network-type-marker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './network-type-marker.component.html',
  styleUrls: ['./network-type-marker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NetworkTypeMarkerComponent {
  @Input() type: NetworkType;

  public readonly NETWORK_TYPE = NetworkType;
}
